/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ReplyListContainerLastFlattened_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"CommentContainer_viewer" | "IgnoredTombstoneOrHideContainer_viewer">;
    readonly " $refType": "ReplyListContainerLastFlattened_viewer";
};
export type ReplyListContainerLastFlattened_viewer$data = ReplyListContainerLastFlattened_viewer;
export type ReplyListContainerLastFlattened_viewer$key = {
    readonly " $data"?: ReplyListContainerLastFlattened_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"ReplyListContainerLastFlattened_viewer">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ReplyListContainerLastFlattened_viewer",
    "selections": [
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CommentContainer_viewer"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "IgnoredTombstoneOrHideContainer_viewer"
        }
    ],
    "type": "User",
    "abstractKey": null
} as any);
(node as any).hash = '82b9deea477feb1fae70e1aab9fbde91';
export default node;
